module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TV-3cfa7ca1592d3a0fce79eed1b9a9dbb7.png";